import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { getProductContext } from '@/logic/main/utils';
import models from '@/model';
import { getLocale } from '@/utils';

export const fetchRecommendedGamesByAccountID = (
  context: LogicContext
) => async () => {
  const product = getProductContext();
  const authToken = context.user.authToken?.access_token;
  const deviceType = context.deviceInfo.deviceType;

  if (product && authToken) {
    const { status, data } = await models.fetchRecommendedGamesByAccountID({
      authToken,
      title: product,
      locale: getLocale(config),
      market_country: config.viewer_country,
      market_region: config.viewer_region,
      device_type: deviceType,
      limit: 10,
    });

    return {
      status,
      recommendedGames: data,
    };
  }

  console.error(
    'There was a problem while fetching Recommended Games. Undefined product name or authToken.'
  );
  return {
    status: 400,
    recommendedGames: [],
  };
};
